import React from 'react';

const PlantMonitoring: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Plant Monitoring</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Plant monitoring features coming soon...</p>
      </div>
    </div>
  );
};

export default PlantMonitoring;
